import React, { useState, useEffect } from 'react'
import { FormContentsModel } from '../models/StoreDetailModel'
import { Platform, Pressable, Text, View } from 'react-native'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useNavigation } from '@react-navigation/native'
import { StackNavigationProp } from '@react-navigation/stack'
import { DotsNavigation } from '../../navigation/stacks/NavigationStack'
import styles from './ImageFormItemStyles'
import useImageLoader from '../../../hooks/useImageLoader'
import { PATH_ASSETS } from '../../../utils/Constants'
import { Loader } from '../../customUtils/Components/Loader'
import { withOpacity } from '../../../utils/functions.utils'
import theme from '../../../../theme'
import { Image } from 'expo-image'
import { Ionicons } from '@expo/vector-icons'

export const ImageFormItem = ({ item }: { item: FormContentsModel }) => {
    const navigation = useNavigation<StackNavigationProp<DotsNavigation>>()

    const goToLink = (data: string) => {
        if (!data) return
        const params = {
            link: data,
        }
        navigation.navigate('WebView', params as undefined)
    }

    const [imageAspectRatio, setImageAspectRatio] = useState(1)

    const title = item.title && item.title != '' ? item.title : 'Ir a formulario'

    const image =
        item?.media && item?.media != ''
            ? { uri: item.media }
            : require('../../../../assets/wiseObservations.png')
    const hasDescription = !!item?.description_short

    return (
        <Pressable
            onPress={() => goToLink(item.description)}
            style={{
                flexDirection: 'row',
                flex: 1,

                marginHorizontal: 16,
                marginVertical: 10,
                borderRadius: 8,
                backgroundColor: 'white',
                borderColor: '#F1F2FF',
                shadowColor: '#a9a9bb',
                shadowOffset: { width: 0, height: 3 },
                shadowOpacity: 0.25,
                shadowRadius: 12,
                elevation: 4,
                paddingVertical: 20,
                paddingHorizontal: 16,
            }}
        >
            <Image
                style={{
                    width: 72,
                    height: 72,
                    borderRadius: 8,
                    overflow: 'hidden',
                    backgroundColor: withOpacity(theme.colors.colorPrimary, 0.08),
                }}
                source={image}
            />
            <View
                style={{
                    flex: 1,
                    gap: 8,
                    marginStart: 16,
                }}
            >
                <Text
                    style={{
                        fontWeight: 'bold',
                        fontSize: 16,
                        color: theme.colors.textPrimary,
                    }}
                >
                    {item.title}
                </Text>
                {hasDescription && (
                    <Text
                        style={{
                            color: theme.colors.darkGray,
                            fontWeight: '400',
                        }}
                    >
                        {item.description_short}
                    </Text>
                )}
                <Text
                    style={{
                        alignSelf: 'flex-start',
                        marginTop: 4,
                        backgroundColor: withOpacity(
                            theme.colors.colorPrimary,
                            0.12,
                        ),

                        color: theme.colors.colorPrimary,
                        fontWeight: '400',
                        textTransform: 'uppercase',
                        fontSize: 11,
                        borderRadius: 6,
                        paddingHorizontal: 12,
                        paddingVertical: 5.5,
                    }}
                >
                    {'Formulario externo'}
                </Text>
            </View>
            <Ionicons
                name='chevron-forward'
                size={16}
                color={theme.colors.colorPrimary}
                style={{ alignSelf: 'center', marginStart: 12 }}
            />
        </Pressable>
    )
}
